var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"_center_tree"},[_c('vue-okr-tree',{attrs:{"data":_vm.treeData,"animate":"","current-lable-class-name":".label-bg-blue","default-expand-all":"","direction":"horizontal","label-class-name":".label-class-blue","show-collapsable":"","showNodeNum":""},on:{"node-click":_vm.handleNodeClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }